import { Link } from "react-router-dom";

export const Brand = ({ to = "/", size = "md" }) => (
  <Link to={to} className="group flex items-center gap-2.5" data-testid="brand-logo-link">
    <img src="/brand/logo-128.webp" alt="Scoopz Private Rides"
      className={`${size === "lg" ? "h-12 w-12" : "h-10 w-10"} rounded-full shadow-[0_0_16px_hsl(var(--neon-violet)/0.6)] transition-transform group-hover:scale-105`} />
    <span className="leading-none">
      <span className="block font-display text-xl font-extrabold tracking-tight text-white">
        Scoop<span className="neon-text-lime">z</span>
      </span>
      <span className="mt-0.5 hidden text-[9px] font-semibold uppercase tracking-[0.35em] text-white/60 sm:block">Private rides</span>
    </span>
  </Link>
);
